/**
 * foreground 서비스는 앱이 열려 있을 때 푸시가 포그라운드로 올 경우 페이지에 시그널을 주기 위해서 이용합니다.
 */
import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ForegroundService {
  public pushPressed$ = new Subject()

  constructor() {}
}
